function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 16C5 12.6863 7.68629 10 11 10C12.9618 10 14.7035 10.9399 15.8008 12.4003L18.1992 10.5983C16.5598 8.41613 13.945 7 11 7C6.02944 7 2 11.0294 2 16C2 20.9706 6.02944 25 11 25C13.945 25 16.5598 23.5839 18.1992 21.4017L15.8008 19.5997C14.7035 21.0601 12.9618 22 11 22C7.68629 22 5 19.3137 5 16ZM24.4998 14.4333V12.0008C24.4998 11.5769 24.9942 11.3453 25.3199 11.6167L30.0389 15.5491C30.2787 15.749 30.2787 16.1174 30.0389 16.3173L25.3199 20.2498C24.9942 20.5212 24.4998 20.2897 24.4998 19.8657V17.4333H18.9998C18.1714 17.4333 17.4998 16.7617 17.4998 15.9333C17.4998 15.1048 18.1714 14.4333 18.9998 14.4333H24.4998ZM13.0667 16C13.0667 17.1046 12.1712 18 11.0667 18C9.96209 18 9.06666 17.1046 9.06666 16C9.06666 14.8954 9.96209 14 11.0667 14C12.1712 14 13.0667 14.8954 13.0667 16Z",
  fill: "white"
});

const SvgIcMenuSources = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMenuSources, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-menu-sources.17551c2a.svg";
export { ForwardRef as ReactComponent };